<template>
  <div class="map-container">
    <!-- Навигация -->
    <nav class="navbar">
      <div class="user-info">
        <span v-if="auth.isAuthenticated">
          Добро пожаловать, {{ auth.user.username }} ({{ auth.user.role }})
          <button @click="auth.logout()" class="logout-btn">Выйти</button>
        </span>
        <span v-else>Не авторизован</span>
      </div>
      
      <!-- Переключатель каталогов -->
      <div class="catalog-selector">
        <label>Каталоги материалов наблюдения (из ТЗ): </label>
        <div class="catalog-buttons">
          <button 
            v-for="catalog in catalogs" 
            :key="catalog.value"
            @click="selectCatalog(catalog.value)"
            :class="['catalog-btn', { 'active': selectedCatalog === catalog.value }]"
          >
            {{ catalog.label }}
          </button>
        </div>
        
        <!-- Кнопки действий -->
        <div class="action-buttons">
          <button @click="openUploadModal" class="upload-data-btn">
            📤 Определить адрес
          </button>
        </div>
        
        <!-- Кнопка загрузки файлов (только для пользовательского каталога) -->
      </div>
    </nav>

    <!-- Основной контент -->
    <div class="content-wrapper">
      <!-- Карта -->
      <div ref="mapContainer" class="map"></div>
      
      <!-- Боковая панель с информацией -->
      <div class="info-panel">
        <div class="panel-header">
          <h3>Информация об объекте</h3>
          <button v-if="selectedObject" @click="clearSelection" class="close-btn">×</button>
        </div>
        
        <div class="panel-content">
          <!-- Поиск -->
          <div class="search-section">
            <input 
              v-model="searchQuery" 
              type="text" 
              placeholder="Введите координаты в формате (ГГ.ггггг) или адрес объекта..." 
              class="search-input"
            />
            <button @click="performSearch" :disabled="searchLoading" class="search-btn">
        {{ searchLoading ? 'Поиск...' : 'Найти' }}
      </button>
          </div>
    <!-- РЕЗУЛЬТАТЫ ПОИСКА -->
    <div v-if="searchResults && searchResults.success" class="search-results-section">
      <h4>Результаты поиска</h4>
      
      <!-- Информация о найденном адресе -->
      <div v-if="searchResults.results[0]?.address" class="address-info">
        <h5>📍 Найденный адрес:</h5>
        <p><strong v-if="searchResults.results[0].address.formatted_address">{{ searchResults.results[0].address.formatted_address }}</strong>
          <strong v-else>{{ searchResults.results[0].address.full_address }}</strong></p>
        <p v-if="searchResults.results[0].address.lat">Координаты: {{ searchResults.results[0].address.lat }}, {{ searchResults.results[0].address.lon }}</p>
        <p v-else>Координаты: {{ searchResults.results[0].coordinates.lat }}, {{ searchResults.results[0].coordinates.lon }}</p>
        <button 
          @click="centerOnAddress(searchResults.results[0].address)"
          class="center-btn"
        >
          📍 Показать на карте
        </button>
      </div>

      <!-- Изображения -->
      <div v-if="getAllSearchImages().length > 0" class="search-images">
        <h5>Найдено изображений: {{ getAllSearchImages().length }}</h5>
        <div class="images-grid">
          <div 
            v-for="(image, index) in getAllSearchImages()" 
            :key="index"
            class="image-item"
          >
            <img 
              :src="image.thumbnail_url" 
              :alt="image.title"
              class="search-image"
              @click="openImage(image.page_url)"
            />
            <div class="image-title">{{ image.title }}</div>
          </div>
        </div>
      </div>
    </div>

          <!-- Основная информация -->
          <div v-if="selectedObject" class="object-info">
            <!-- Кнопка экспорта -->

            <div class="info-section">
              <h4>Основная информация</h4>

              <!-- Изображения -->
              <div class="images-section">
                <div class="images-grid">
                  <div class="image-item" v-if="selectedObject.properties.catalog_id && selectedObject.properties.name">
                    <label>Оригинал 🔗</label>
                    <a 
                      :href="`https://hack2025.easy-sat.ru/storage/o/${selectedObject.properties.catalog_id}/${selectedObject.properties.name}.jpg`" 
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                    <img 
                      :src="`https://hack2025.easy-sat.ru/storage/o/${selectedObject.properties.catalog_id}/${selectedObject.properties.name}.jpg`" 
                      class="object-image" height="100px"
                      @error="handleImageError"
                    /></a>
                  </div>
                  <div class="image-item" v-if="selectedObject.properties.catalog_id && selectedObject.properties.name">
                    <label>Сегментация 🔗</label>
                    <a 
                      :href="`https://hack2025.easy-sat.ru/storage/r/${selectedObject.properties.catalog_id}/${selectedObject.properties.name}_seg_clr.png`" 
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                    <img
                      :src="`https://hack2025.easy-sat.ru/storage/r/${selectedObject.properties.catalog_id}/${selectedObject.properties.name}_seg_clr.png`" 
                      class="object-image" height="100px"
                      @error="handleImageError"
                    /></a>
                  </div>
                  <div class="image-item" v-if="selectedObject.properties.catalog_id && selectedObject.properties.name">
                    <label>Аннотации <a :href="`https://hack2025.easy-sat.ru/storage/r/${selectedObject.properties.catalog_id}/geojson/${selectedObject.properties.name}.geojson`" target="_blank">🔗</a></label>
                    <a 
                      :href="`https://hack2025.easy-sat.ru/storage/r/${selectedObject.properties.catalog_id}/${selectedObject.properties.name}_t.png`" 
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                    <img 
                      :src="`https://hack2025.easy-sat.ru/storage/r/${selectedObject.properties.catalog_id}/${selectedObject.properties.name}_t.png`" 
                      class="object-image" height="100px"
                      @error="handleImageError"
                    /></a>
                  </div>

          
                </div>
              </div>
              <div class="building-comparison" v-if="searchResults?.building_comparison?.top_matches?.length">
  <h5>🔍 Сравнение с ближайшими зданиями</h5>
  <p>На основе анализа фрагмента здания определены наиболее вероятные адреса:</p>
  
  <div class="top-matches">
    <div 
      v-for="(match, index) in searchResults.building_comparison.top_matches" 
      :key="match.building_id"
      class="match-item"
      :class="{ 'best-match': index === 0 }"
    >
      <div class="match-rank">#{{ index + 1 }}</div>
      <div class="similarity-score">
        {{ match.similarity_percent.toFixed(1) }}%
      </div>
      <div class="match-info">
        <div class="building-address">
          <strong>{{ match.address || match.building_name }}</strong>
        </div>
        <div class="match-details">
          <span class="distance">📍 {{ match.distance }}м</span>
          <span class="similarity">⚡ Схожесть: {{ match.similarity.toFixed(3) }}</span>
        </div>
      </div>
      <img 
        :src="match.image_url" 
        :alt="match.building_name"
        class="match-image"
        @click="openImage(match.image_url)"
      />
    </div>
  </div>
  
  <div class="comparison-stats">
    Всего сравнено: {{ searchResults.building_comparison.total_buildings_compared }} зданий
  </div>
</div>

              <!-- Блок поиска -->
              <div class="search-section" v-if="selectedObject">
                
                <!-- Вырезанная область -->
                <div class="cropped-image" v-if="croppedImageUrl">
                  <h5>Область поиска:</h5>
                  <img :src="croppedImageUrl" class="object-image" />
                </div>
                
                <!-- Результаты поиска -->
                <div class="search-results" v-if="searchResults">
                  <h5>Результаты поиска (найдено: {{ searchResults.length }})</h5>
                  <div class="results-grid">
                    <div 
                      v-for="result in searchResults" 
                      :key="result.rank" 
                      class="result-item"
                    >
                      <div class="result-rank">#{{ result.rank }}</div>
                      <img 
                        :src="result.thumbnail" 
                        :alt="result.title"
                        class="result-thumbnail"
                        @click="openResult(result.page_url)"
                      />
                      <div class="result-info">
                        <div class="result-title" :title="result.title">
                          {{ result.title }}
                        </div>
                        <div class="result-snippet">
                          {{ result.snippet }}
                        </div>
                        <a 
                          :href="result.page_url" 
                          target="_blank" 
                          class="result-link"
                        >
                          Открыть источник
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- Ошибка -->
                <div class="search-error" v-if="searchError">
                  {{ searchError }}
                </div>
              </div>

              <div class="info-grid">
                <div class="info-item">
                  <label>Название:</label>
                  <span>{{ selectedObject.properties.name || 'Не указано' }}</span>
                </div>
                <div class="info-item">
                  <label>Направление:</label>
                  <span>{{ selectedObject.properties.direction ? selectedObject.properties.direction + '°' : 'Не указано' }}</span>
                </div>
                <div class="info-item">
                  <label>Каталог:</label>
                  <span>{{ selectedObject.properties.catalog || 'Не указан' }}</span>
                </div>
                <div class="info-item">
                  <label>ID каталога:</label>
                  <span>{{ selectedObject.properties.catalog_id || 'Не указан' }}</span>
                </div>
                <div class="info-item">
                  <label>Координаты:</label>
                  <span>{{ selectedObject.coordinates.join(', ') }}</span>
                </div>
              </div>
            </div>

            <!-- Дополнительная информация из API -->
            <div class="info-section">
              <h4>Окружающие объекты</h4>
              <div v-if="apiDataLoading" class="loading">Загрузка информации об окружении...</div>
              <div v-else-if="apiData" class="api-data">
                <!-- Текущая улица -->
                <div v-if="apiData.current_street" class="object-group">
                  <h5>📍 Текущее местоположение:</h5>
                  <div class="object-item">
                    <strong>{{ apiData.current_street.name || 'Улица' }}</strong>
                    <span class="distance">{{ apiData.current_street.distance }}м</span>
                    <div class="tags" v-if="Object.keys(apiData.current_street.tags).length > 0">
                      <span v-for="(value, key) in apiData.current_street.tags" :key="key" class="tag">
                        {{ key }}: {{ value }}
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Здания -->
                <div v-if="apiData.buildings.length > 0" class="object-group">
                  <h5>🏢 Здания и сооружения:</h5>
                  <div v-for="building in apiData.buildings" :key="building.osm_id" class="object-item">
                    <strong>{{ building.name }}</strong>
                    <span class="distance">{{ building.distance }}м</span>
                    <div class="tags" v-if="Object.keys(building.tags).length > 0">
                      <span v-for="(value, key) in building.tags" :key="key" class="tag">
                        {{ key }}: {{ value }}
                      </span>
                    </div>
                    <div style="display:block">
                      <img 
                        v-for="(image, index) in building.yandex_search_results?.images || []" 
                        :key="index" 
                        :src="image.image_url" 
                        height="100px" 
                        :alt="'Image ' + index"
                        @error="handleImageError"
                      >
                    </div>
                  </div>
                </div>

                <!-- Территории -->
                <div v-if="apiData.territories.length > 0" class="object-group">
                  <h5>🌳 Территории и зоны:</h5>
                  <div v-for="territory in apiData.territories" :key="territory.osm_id" class="object-item">
                    <strong>{{ territory.name || territory.tags?.landuse || territory.tags?.leisure || 'Территория' }}</strong>
                    <span class="distance">{{ territory.distance }}м</span>
                    <div class="tags" v-if="Object.keys(territory.tags || {}).length > 0">
                      <span v-for="(value, key) in territory.tags" :key="key" class="tag">
                        {{ key }}: {{ value }}
                      </span>
                    </div>
                  </div>
                </div>
                
                <!-- Улицы -->
                <div v-if="apiData.streets.length > 0" class="object-group">
                  <h5>🛣️ Улицы поблизости:</h5>
                  <div v-for="street in apiData.streets" :key="street.osm_id" class="object-item">
                    <strong>{{ street.name || 'Улица' }}</strong>
                    <span class="distance">{{ street.distance }}м</span>
                    <div class="tags" v-if="Object.keys(street.tags || {}).length > 0">
                      <span v-for="(value, key) in street.tags" :key="key" class="tag">
                        {{ key }}: {{ value }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="no-data">Нет информации об окружающих объектах</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Компоненты -->
    <UserUpload 
      :show-upload-modal="showUploadModal"
      @close="closeUploadModal"
      @upload-complete="handleUploadComplete"
    />

    <SearchPanel 
      :show-search-panel="showSearchPanel"
      @close="closeSearchPanel"
      @search-complete="handleSearchComplete"
    />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
import { useAuthStore } from '@/stores/auth';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import UserUpload from './UserUpload.vue';

export default {
  name: 'MapComponent',
  components: {
    UserUpload,
  },
  
  setup() {
    const mapContainer = ref(null);
    const map = ref(null);
    const auth = useAuthStore();
    const layersInitialized = ref(false);
    const fileInput = ref(null);
    
    // Реактивные переменные
    const selectedObject = ref(null);
    const searchQuery = ref('');
    const exportLoading = ref(false);
    const apiData = ref(null);
    const apiDataLoading = ref(false);
    const selectedFeatureId = ref(null);
    const searchResults = ref(false);
    const searchLoading = ref(false);
    const searchError = ref(false);
    const croppedImageUrl = ref(false);
    const showUploadModal = ref(false);
    const showSearchPanel = ref(false);

    // Каталоги
    const catalogs = ref([
      { value: 'all', label: 'Все каталоги' },
      { value: '1', label: 'building_echd' },
      { value: '2', label: 'garbage_echd' },
      { value: '3', label: 'Град. Июль' },
      { value: '4', label: 'Стр. пл. Июль' },
      { value: '5', label: 'Град. Август' },
      { value: '6', label: 'Стр. пл. Август' },
    ]);
    
    const selectedCatalog = ref('all');
    const uploading = ref(false);

    // Функция для создания SVG сектора обзора
    const createSectorDataURL = (direction, fov = 60, radius = 50) => {
      const svgString = direction !== null ? 
          createCameraSectorSVG(direction, fov, radius) : 
          createCircleSVG(radius);
      
      const encodedSVG = encodeURIComponent(svgString)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
      
      return `data:image/svg+xml;utf8,${encodedSVG}`;
    };

    const getAllSearchImages = () => {
  if (!searchResults.value) return [];
  
  // Для результатов поиска через Yandex
  if (searchResults.value.results && Array.isArray(searchResults.value.results)) {
    return searchResults.value.results.flatMap(result => result.images || []);
  }
  
  // Для результатов поиска по координатам/адресу
  if (searchResults.value.results && searchResults.value.results[0]?.images) {
    return searchResults.value.results[0].images;
  }
  
  return [];
};

const centerOnAddress = (address) => {
  if (map.value && address.lat && address.lon) {
    map.value.flyTo({
      center: [address.lon, address.lat],
      zoom: 16
    })
  }
}

// Функция для открытия изображения
const openImage = (url) => {
  window.open(url, '_blank')
}

    const createCameraSectorSVG = (direction, fov = 30, radius = 5) => {
      const halfFov = fov / 2;
      const startAngle = direction - halfFov;
      const endAngle = direction + halfFov;
      
      const startRad = (startAngle - 90) * Math.PI / 180;
      const endRad = (endAngle - 90) * Math.PI / 180;
      
      const startX = 50 + radius * Math.cos(startRad);
      const startY = 50 + radius * Math.sin(startRad);
      const endX = 50 + radius * Math.cos(endRad);
      const endY = 50 + radius * Math.sin(endRad);
      
      return `
        <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <path d="M50,50 L${startX},${startY} A${radius},${radius} 0 0,1 ${endX},${endY} Z" 
                fill="rgba(0,170,255,0.3)" stroke="#00aaff" stroke-width="1"/>
        </svg>
      `;
    };

    const createCircleSVG = (radius = 50) => {
      return `
        <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <circle cx="50" cy="50" r="${radius}" 
                  fill="rgba(0,170,255,0.3)" stroke="#ff6464" stroke-width="1"/>
        </svg>
      `;
    };

    // Загрузка кастомных иконок
    const loadCustomIcons = () => {
      return new Promise((resolve) => {
        const angles = [60];
        let loaded = 0;
        const totalToLoad = angles.length + 1;
        
        const circleDataURL = createSectorDataURL(null, 30, 50);
        const circleImg = new Image();
        circleImg.onload = () => {
          if (!map.value.hasImage('camera-circle')) {
            map.value.addImage('camera-circle', circleImg);
          }
          loaded++;
          if (loaded === totalToLoad) resolve();
        };
        circleImg.src = circleDataURL;
        
        angles.forEach(angle => {
          const dataURL = createSectorDataURL(0, angle/2, 500);
          const img = new Image();
          img.onload = () => {
            if (!map.value.hasImage(`camera-sector-${angle}`)) {
              map.value.addImage(`camera-sector-${angle}`, img);
            }
            loaded++;
            if (loaded === totalToLoad) resolve();
          };
          img.src = dataURL;
        });
      });
    };

    // Выбор каталога
    const selectCatalog = (catalog) => {
      selectedCatalog.value = catalog;
      filterByCatalog();
    };

    // Фильтрация по каталогу
    const filterByCatalog = () => {
      if (!map.value || !layersInitialized.value) return;
      
      if (selectedCatalog.value === 'all') {
        map.value.setFilter('camera-centers', null);
        map.value.setFilter('camera-sectors', null);
      } else {
        const catalogValue = selectedCatalog.value === '99' ? 99 : parseInt(selectedCatalog.value);
        const filter = ['==', ['get', 'catalog_id'], catalogValue];
        
        console.log('Applying filter for catalog:', catalogValue, filter);
        
        map.value.setFilter('camera-centers', filter);
        map.value.setFilter('camera-sectors', filter);
      }
    };

    // Методы для модальных окон
    const openUploadModal = () => {
      showUploadModal.value = true;
    };

    const closeUploadModal = () => {
      showUploadModal.value = false;
    };

    const handleUploadComplete = (result) => {
      console.log('Upload completed:', result);
      if (map.value && map.value.getSource('points')) {
        map.value.getSource('points').reload();
      }
      selectCatalog('99');
    };

    const openSearchPanel = () => {
      showSearchPanel.value = true;
    };

    const closeSearchPanel = () => {
      showSearchPanel.value = false;
    };

    const handleSearchComplete = (result) => {
      console.log (result)
      if (map.value && map.value.getSource('points')) {
        map.value.getSource('points').reload();
      }
      selectCatalog('99');
    };

    // Загрузка файлов
    const triggerFileInput = () => {
      fileInput.value?.click();
    };

    const handleFileUpload = async (event) => {
      const files = event.target.files;
      if (!files.length) return;

      uploading.value = true;
      
      try {
        const formData = new FormData();
        
        for (let i = 0; i < files.length; i++) {
          formData.append('files', files[i]);
        }
        
        formData.append('catalog', '99');
        
        const response = await fetch('https://hack2025.easy-sat.ru/api/upload', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          const result = await response.json();
          alert(`Файлы успешно загружены! Загружено объектов: ${result.uploaded_count}`);
          
          if (map.value && map.value.getSource('points')) {
            map.value.getSource('points').reload();
          }
        } else {
          alert('Ошибка при загрузке файлов');
        }
      } catch (error) {
        console.error('Ошибка загрузки:', error);
        alert('Ошибка при загрузке файлов');
      } finally {
        uploading.value = false;
        if (fileInput.value) {
          fileInput.value.value = '';
        }
      }
    };

    // Подсветка выбранной точки
    const highlightSelectedFeature = () => {
      if (selectedFeatureId.value !== null) {
        map.value.setFeatureState(
          { source: 'points', sourceLayer: 'points', id: selectedFeatureId.value },
          { selected: false }
        );
      }

      if (selectedObject.value && selectedObject.value.id) {
        selectedFeatureId.value = selectedObject.value.id;
        map.value.setFeatureState(
          { source: 'points', sourceLayer: 'points', id: selectedObject.value.id },
          { selected: true }
        );
      }
    };

    // Запрос дополнительных данных из API
    const fetchAdditionalData = async (feature) => {
      apiDataLoading.value = true;
      apiData.value = null;
      
      try {
        const params = new URLSearchParams({
          lat: feature.geometry.coordinates[1],
          lon: feature.geometry.coordinates[0]
        });
        
        if (feature.properties.direction) {
          params.append('direction', feature.properties.direction);
        }
        
        const response = await fetch(`https://hack2025.easy-sat.ru/api/nearby-objects?${params}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          apiData.value = data;
        } else {
          console.warn('API недоступен или данные не найдены');
        }
      } catch (error) {
        console.warn('Ошибка при загрузке дополнительных данных (API недоступен):', error);
      } finally {
        apiDataLoading.value = false;
      }
    };

//     const searchSimilarObjects = async (feature) => {
//   searchLoading.value = true;
//   searchResults.value = null;
//   searchError.value = null;
//   croppedImageUrl.value = null;

//   try {
//     // Подготавливаем данные о зданиях для отправки
//     let buildingImagesData = [];
    
//     if (apiData.value?.buildings) {
//       buildingImagesData = apiData.value.buildings.map(building => ({
//         osm_id: building.osm_id,
//         name: building.name,
//         address: building.address || building.formatted_address,
//         distance: building.distance,
//         yandex_search_results: building.yandex_search_results,
//         image_url: building.image_url
//       }));
//     }

//   //  const params = new URLSearchParams({
//   //     catalog_id: feature.properties.catalog_id,
//   //     image_name: feature.properties.name,
//   //     object_id: feature.properties.id,
//   //     building_images: JSON.stringify(buildingImagesData)  // Отправляем как JSON строку
//   //   });
    
//   //   const response = await fetch(`https://hack2025.easy-sat.ru/api/search-by-object?${params}`, {
//   //     method: 'GET',
//   //     headers: {
//   //       'Content-Type': 'application/json',
//   //     }
//   //   });
    
//   //   if (response.ok) {
//   //     const data = await response.json();
      
//   //     if (data.success) {
//   //       searchResults.value = data;
//   //       croppedImageUrl.value = data.cropped_image_url;
        
//   //       console.log('Результаты сравнения с зданиями:', data.building_comparison);
//   //     } else {
//   //       searchError.value = data.error || 'Произошла ошибка при поиске';
//   //     }
//   //   } else {
//   //     searchError.value = 'Сервер недоступен';
//   //   }
//   } catch (error) {
//     searchError.value = 'Ошибка при поиске похожих объектов';
//     console.error('Search error:', error);
//   } finally {
//     searchLoading.value = false;
//   }
// };


    // Обработчик выбора объекта
    const handleObjectSelect = (feature, coordinates) => {
      selectedObject.value = {
        properties: feature.properties,
        coordinates: [coordinates.lng, coordinates.lat],
        id: feature.id
      };
      
      highlightSelectedFeature();
      fetchAdditionalData(feature);
      //searchSimilarObjects(feature);
    };

    // Очистка выбора
    const clearSelection = () => {
      if (selectedFeatureId.value !== null) {
        map.value.setFeatureState(
          { source: 'points', sourceLayer: 'points', id: selectedFeatureId.value },
          { selected: false }
        );
        selectedFeatureId.value = null;
      }
      selectedObject.value = null;
      apiData.value = null;
      searchQuery.value = '';
    };

    const performSearch = async () => {
        if (!searchQuery.value.trim()) return
        
        searchLoading.value = true
        searchError.value = ''
        searchResults.value = null
  
        try {
          const response = await fetch('https://hack2025.easy-sat.ru/api/search', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              query: searchQuery.value,
              user_id: auth.user?.id || 'anonymous'
            })
          })
  
          if (response.ok) {
            const data = await response.json()
            if (data.success) {
              searchResults.value = data
            } else {
              searchError.value = data.error || 'Произошла ошибка при поиске'
            }
          } else {
            searchError.value = 'Ошибка сервера при выполнении поиска'
          }
        } catch (error) {
          searchError.value = 'Ошибка соединения'
          console.error('Search error:', error)
        } finally {
          searchLoading.value = false
        }
      }

    // Экспорт в Excel
    const exportToExcel = async () => {
      if (!selectedObject.value) return;
      
      exportLoading.value = true;
      try {
        const response = await fetch('https://hack2025.easy-sat.ru/api/export/excel', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            objectId: selectedObject.value.properties.catalog_id || selectedObject.value.id,
            objectData: selectedObject.value.properties,
            additionalData: apiData.value
          })
        });

        if (response.ok) {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `object_${selectedObject.value.properties.name || selectedObject.value.id}.xlsx`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        } else {
          alert('Ошибка при экспорте данных');
        }
      } catch (error) {
        console.error('Ошибка экспорта:', error);
        alert('Ошибка при экспорте данных');
      } finally {
        exportLoading.value = false;
      }
    };

    // Обработчик ошибок загрузки изображений
    const handleImageError = (event) => {
      console.log (event)
      console.log ('была проблема, но ее пропустили')
    };

    const openResult = (url) => {
      window.open(url, '_blank');
    };

    // Инициализация карты
    const initializeMap = () => {
      if (!mapContainer.value) return;

      map.value = new maplibregl.Map({
        container: mapContainer.value,
        style: 'https://api.maptiler.com/maps/streets-v2/style.json?key=Guc6guvPbjpNUaxIOdEC&lang=ru',
        center: [37.618423, 55.751244],
        zoom: 17
      });

      map.value.addControl(new maplibregl.NavigationControl());

      map.value.on('load', () => {
        if (!map.value.getSource('points')) {
          map.value.addSource('points', {
            type: 'vector',
            tiles: ['https://hack2025.easy-sat.ru/tiles/{z}/{x}/{y}.pbf']
          });
        }

        map.value.on('sourcedata', async (e) => {
          if (e.sourceId === 'points' && e.isSourceLoaded && !layersInitialized.value) {
            console.log('Source loaded successfully');
            layersInitialized.value = true;
            
            try {
              await loadCustomIcons();
              addCameraLayers();
              add3DBuildings();
              setupEventHandlers();
              
              filterByCatalog();
            } catch (error) {
              console.error('Error initializing layers:', error);
            }
          }
        });

        map.value.on('error', (e) => {
          console.error('Map error:', e);
        });
      });
    };

    // Добавление слоев камер с подсветкой
    const addCameraLayers = () => {
      if (map.value.getLayer('camera-sectors')) return;

      map.value.addLayer({
        id: 'camera-sectors',
        type: 'symbol',
        source: 'points',
        'source-layer': 'points',
        minzoom: 8,
        layout: {
          'icon-image': [
            'case',
            ['!=', ['get', 'direction'], null],
            'camera-sector-60',
            'camera-circle'
          ],
          'icon-rotate': [
            'case',
            ['!=', ['get', 'direction'], null],
            ['get', 'direction'],
            0
          ],
          'icon-rotation-alignment': 'map',
          'icon-pitch-alignment': 'map',
          'icon-size': [
            'interpolate', ['linear'], ['zoom'],
            8, 0.3,
            12, 0.5,
            16, 0.6,
          ],
          'icon-allow-overlap': false,
          'icon-ignore-placement': true
        },
        paint: {
          'icon-opacity': 0.7
        }
      });

      map.value.addLayer({
        id: 'camera-centers',
        type: 'circle',
        source: 'points',
        'source-layer': 'points',
        minzoom: 8,
        paint: {
          'circle-radius': [
            'interpolate', ['linear'], ['zoom'],
            8, 3,
            16, 6
          ],
          'circle-color': [
            'case',
            ['boolean', ['feature-state', 'selected'], false],
            '#ff0000',
            ['!=', ['get', 'direction'], null],
            '#ff4444',
            '#888888'
          ],
          'circle-stroke-color': [
            'case',
            ['boolean', ['feature-state', 'selected'], false],
            '#ffffff',
            '#ffffff'
          ],
          'circle-stroke-width': [
            'case',
            ['boolean', ['feature-state', 'selected'], false],
            3,
            2
          ],
          'circle-opacity': 0.9
        }
      });
    };

    // Добавление 3D зданий
    const add3DBuildings = () => {
      if (map.value.getSource('openfreemap')) return;

      map.value.addSource('openfreemap', {
        type: 'vector',
        url: 'https://tiles.openfreemap.org/planet'
      });

      const layers = map.value.getStyle().layers;
      let labelLayerId;
      
      for (let i = 0; i < layers.length; i++) {
        if (layers[i].type === 'symbol' && layers[i].layout && layers[i].layout['text-field']) {
          labelLayerId = layers[i].id;
          break;
        }
      }

      if (!map.value.getLayer('3d-buildings')) {
        map.value.addLayer({
          'id': '3d-buildings',
          'source': 'openfreemap',
          'source-layer': 'building',
          'type': 'fill-extrusion',
          'minzoom': 15,
          'filter': ['!=', ['get', 'hide_3d'], true],
          'paint': {
            'fill-extrusion-color': [
              'interpolate',
              ['linear'],
              ['get', 'render_height'], 
              0, 'lightgray', 
              200, 'royalblue', 
              400, 'lightblue'
            ],
            'fill-extrusion-height': [
              'interpolate',
              ['linear'],
              ['zoom'],
              15, 0,
              16, ['get', 'render_height']
            ],
            'fill-extrusion-base': [
              'case',
              ['>=', ['get', 'zoom'], 16],
              ['get', 'render_min_height'], 
              0
            ],
            'fill-extrusion-opacity': 0.5
          }
        }, labelLayerId);
      }
    };

    // Обработчики событий
    const setupEventHandlers = () => {
      map.value.off('click', 'camera-centers');
      map.value.off('mouseenter', 'camera-centers');
      map.value.off('mouseleave', 'camera-centers');

      map.value.on('click', 'camera-centers', (e) => {
        const feature = e.features[0];
        const coordinates = e.lngLat;
        handleObjectSelect(feature, coordinates);
      });

      map.value.on('mouseenter', 'camera-centers', () => {
        map.value.getCanvas().style.cursor = 'pointer';
      });

      map.value.on('mouseleave', 'camera-centers', () => {
        map.value.getCanvas().style.cursor = '';
      });

      map.value.on('click', (e) => {
        const features = map.value.queryRenderedFeatures(e.point, {
          layers: ['camera-centers']
        });
        if (features.length === 0) {
          clearSelection();
        }
      });
    };

    onMounted(() => {
      initializeMap();
      auth.initialize();
    });

    onUnmounted(() => {
      if (map.value) {
        map.value.remove();
      }
    });

    return {
      mapContainer,
      auth,
      selectedObject,
      searchQuery,
      exportLoading,
      apiData,
      apiDataLoading,
      clearSelection,
      performSearch,
      exportToExcel,
      handleImageError,
      //searchSimilarObjects,
      catalogs,
      selectedCatalog,
      selectCatalog,
      fileInput,
      triggerFileInput,
      handleFileUpload,
      uploading,
      showUploadModal,
      openUploadModal,
      closeUploadModal,
      handleUploadComplete,
      showSearchPanel,
      openSearchPanel,
      closeSearchPanel,
      handleSearchComplete,
      searchResults,
      searchLoading,
      searchError,
      croppedImageUrl,
      openResult,
      getAllSearchImages,
  centerOnAddress,
  openImage
    };
  }
};
</script>

<style scoped>
.map-container {
  position: relative;
  width: 100%;
  height: 100vh;
}

.navbar {
  background: #f8f9fa;
  padding: 10px 20px;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logout-btn {
  background: #dc3545;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
}

.catalog-selector {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.catalog-buttons {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}

.catalog-btn {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
  border-radius: 4px;
}

.catalog-btn.active {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.upload-data-btn,
.search-panel-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.search-panel-btn {
  background: #17a2b8;
}

.upload-section {
  display: flex;
  align-items: center;
  gap: 10px;
}

.upload-btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.upload-status {
  color: #6c757d;
  font-style: italic;
}

.content-wrapper {
  display: flex;
  height: calc(100vh - 60px);
}

.map {
  flex: 1;
  height: 100%;
}

.info-panel {
  width: 400px;
  background: white;
  border-left: 1px solid #dee2e6;
  overflow-y: auto;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #dee2e6;
}

.panel-content {
  padding: 15px;
}

.search-section {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.search-input {
  flex: 1;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.search-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
}

.export-section {
  margin-bottom: 15px;
}

.export-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
}

.export-btn:disabled {
  background: #6c757d;
}

.info-section {
  margin-bottom: 20px;
}

.info-section h4 {
  margin-bottom: 10px;
  color: #333;
}

.images-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 15px;
}

.image-item {
  text-align: center;
}

.image-item label {
  display: block;
  margin-bottom: 5px;
  font-size: 12px;
  color: #666;
}

.object-image {
  max-width: 100%;
  height: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.info-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-item label {
  font-weight: bold;
  color: #555;
}

.object-group {
  margin-bottom: 15px;
}

.object-group h5 {
  margin-bottom: 8px;
  color: #333;
}

.object-item {
  background: #f8f9fa;
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 5px;
}

.distance {
  float: right;
  color: #6c757d;
  font-size: 12px;
}

.tags {
  margin-top: 5px;
}

.tag {
  display: inline-block;
  background: #e9ecef;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 11px;
  margin-right: 5px;
  margin-bottom: 3px;
}

.loading, .no-data {
  text-align: center;
  padding: 20px;
  color: #6c757d;
  font-style: italic;
}

.search-results {
  margin-top: 15px;
}

.results-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.result-item {
  display: flex;
  gap: 10px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.result-rank {
  font-weight: bold;
  color: #007bff;
}

.result-thumbnail {
  width: 80px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}

.result-info {
  flex: 1;
}

.result-title {
  font-weight: bold;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.result-snippet {
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.result-link {
  font-size: 12px;
  color: #007bff;
  text-decoration: none;
}

.result-link:hover {
  text-decoration: underline;
}

.cropped-image {
  text-align: center;
  margin: 15px 0;
}

.search-error {
  background: #f8d7da;
  color: #721c24;
  padding: 10px;
  border-radius: 4px;
  margin-top: 10px;
}
.search-results-section {
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
}

.address-info {
  background: white;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 15px;
  border-left: 4px solid #007bff;
}

.center-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 8px;
}

.search-images {
  margin-top: 15px;
}

.images-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-top: 10px;
}

.search-image {
  width: 100%;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}

.image-title {
  font-size: 12px;
  margin-top: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.building-comparison {
  margin-top: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.top-matches {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}

.match-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: white;
  border-radius: 6px;
  border: 1px solid #dee2e6;
}

.match-item.best-match {
  border-color: #28a745;
  background: #f8fff9;
}

.match-rank {
  background: #007bff;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
}

.similarity-score {
  background: #17a2b8;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
}

.match-info {
  flex: 1;
}

.building-address {
  font-weight: bold;
  margin-bottom: 5px;
}

.match-details {
  display: flex;
  gap: 10px;
  font-size: 12px;
  color: #6c757d;
}

.match-image {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}

.comparison-stats {
  margin-top: 10px;
  text-align: center;
  font-size: 12px;
  color: #6c757d;
}
</style>